import axios from "axios";
import { API_SERVER, API_PORT } from "../store";
//const API_URL = "http://" + API_SERVER + ":" + API_PORT + "/api/bodega/";
//const API_SERVER = "localhost";

const API_URL =
  (API_PORT === 443 ? "https://" : "http://") +
  API_SERVER +
  ":" +
  API_PORT +
  "/api/bodega/";

const dsresbodegadet = async (idSuc, idBod, iNumero) => {
  try {
    // Parámetros de la solicitud GET
    const params = {
      iNumero: iNumero,
      idSucursal: idSuc,
      idBodega: idBod,
    };
    //Authorization: `Bearer ${authToken}`,
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };

    const res = await axios.get(API_URL + "reservadet", { params, headers });

    return res;
  } catch (error) {
    return error.response;
  }
};

const dsdesbodegadet = async (idSuc, idBod, iNumero) => {
  try {
    // Parámetros de la solicitud GET
    const params = {
      iNumero: iNumero,
      idSucursal: idSuc,
      idBodega: idBod,
    };
    //Authorization: `Bearer ${authToken}`,
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };

    const res = await axios.get(API_URL + "despachodet", { params, headers });

    return res;
  } catch (error) {
    return error.response;
  }
};

const dsdesbodegacab = async (
  idSucursal,
  idBodega,
  iNumero,
  DocRef,
  NumDocRef,
  ClaseRef,
  NumPostRef,
  NumGuia,
  ClaseGuia,
  IdTransporte,
  IdCliente,
  Desde,
  Hasta,
  Estado,
) => {
  try {
    // Parámetros de la solicitud GET
    const params = {
      idSucursal: idSucursal,
      idBodega: idBodega,
      iNumero: iNumero,
      DocRef: DocRef,
      NumDocRef: NumDocRef,
      ClaseRef: ClaseRef,
      NumPostRef: NumPostRef,
      NumGuia: NumGuia,
      ClaseGuia: ClaseGuia,
      IdTransporte: IdTransporte,
      IdCliente: IdCliente,
      Desde: Desde,
      Hasta: Hasta,
      Estado: Estado,
    };
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };
    const res = await axios.get(API_URL + "despachocab", { params, headers });
    return res;
  } catch (error) {
    return error.response;
  }
};

const dsMonitor = async (sModo, idSuc, idBod, sEstado) => {
  try {
    // Parámetros de la solicitud GET
    const params = {
      sModo: sModo,
      idSucursal: idSuc,
      idBodega: idBod,
      sEstado: sEstado,
    };
    //Authorization: `Bearer ${authToken}`,
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };

    const res = await axios.get(API_URL + "monitor_bod", { params, headers });
    return res;
  } catch (error) {
    return error.response;
  }
};

const Inventario = async (idSuc, idBod, sCodigo, sCodigoBarra) => {
  try {
    // Parámetros de la solicitud GET
    const params = {
      idSucursal: idSuc,
      idBodega: idBod,
      sCodigo: sCodigo,
      sCodigoBarra: sCodigoBarra,
    };
    //Authorization: `Bearer ${authToken}`,
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };

    const res = await axios.get(API_URL + "inventario", { params, headers });

    return res;
  } catch (error) {
    return error.response;
  }
};

const Inventarioinforme = async (idSuc, idBod, cModo, sFecha) => {
  try {
    // Parámetros de la solicitud GET
    const params = {
      idSucursal: idSuc,
      idBodega: idBod,
      cModo: cModo,
      sFecha: sFecha,
    };
    //Authorization: `Bearer ${authToken}`,
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };

    const res = await axios.get(API_URL + "inventarioinforme", {
      params,
      headers,
    });

    return res;
  } catch (error) {
    return error.response;
  }
};

const Put_Inventario = async (idSuc, idBod, sCod, sCodBarra, dCant) => {
  try {
    // Parámetros de la solicitud PUT
    const params = {
      idSucursal: idSuc,
      idBodega: idBod,
      sCodigo: sCod,
      sCodigoBarra: sCodBarra,
      dCantidad: dCant,
    };
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };

    const res = await axios.put(API_URL + "inventario", params, { headers });

    return res;
  } catch (error) {
    return error.response;
  }
};

const Put_Inventario_Inicializar = async (idSuc, idBod) => {
  try {
    // Parámetros de la solicitud PUT
    const params = {
      idSucursal: idSuc,
      idBodega: idBod,
    };

    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };

    const res = await axios.put(API_URL + "inventarioini", params, { headers });

    return res;
  } catch (error) {
    return error.response;
  }
};

const Put_bodega_resbodegadet = async (
  _pModo,
  _pSucursal,
  _pBodega,
  _pNumero,
  _pItem,
  _pCodigo,
  _pCantidad,
  _pObservacion,
  _pIdEntregado,
  _pFechaHoraEnt,
  _pEntregado,
  _pNoEntregado,
  _pComentario,
  _pDocRef,
  _pSucDocRef,
  _pNumDocRef,
  _pReqDocRef,
  _pItemOrigen,
) => {
  try {
    // Parámetros de la solicitud PUT
    const params = {
      pModo: _pModo,
      pSucursal: _pSucursal,
      pBodega: _pBodega,
      pNumero: _pNumero,
      pItem: _pItem,
      pCodigo: _pCodigo,
      pCantidad: _pCantidad,
      pObservacion: _pObservacion,
      pIdEntregado: _pIdEntregado,
      pFechaHoraEnt: _pFechaHoraEnt,
      pEntregado: _pEntregado,
      pNoEntregado: _pNoEntregado,
      pComentario: _pComentario,
      pDocRef: _pDocRef,
      pSucDocRef: _pSucDocRef,
      pNumDocRef: _pNumDocRef,
      pReqDocRef: _pReqDocRef,
      pItemOrigen: _pItemOrigen,
    };
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };

    const res = await axios.put(API_URL + "resbodegadet", params, { headers });

    return res;
  } catch (error) {
    return error.response;
  }
};

const Put_bodega_desbodegadet = async (
  _pModo,
  _pSucursal,
  _pBodega,
  _pNumero,
  _pItem,
  _pCodigo,
  _pCantidad,
  _pPreparado,
  _pEntregado,
  _pNoEntregado,
  _pComentario,
  _pIdPrepara,
  _pIdEntrega,
) => {
  try {
    const params = {
      pModo: _pModo,
      pSucursal: _pSucursal,
      pBodega: _pBodega,
      pNumero: _pNumero,
      pItem: _pItem,
      pCodigo: _pCodigo,
      pCantidad: _pCantidad,
      pPreparado: _pPreparado,
      pEntregado: _pEntregado,
      pNoEntregado: _pNoEntregado,
      pComentario: _pComentario,
      pIdPrepara: _pIdPrepara,
      pIdEntrega: _pIdEntrega,
    };
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };

    const res = await axios.put(API_URL + "desbodegadet", params, { headers });

    return res;
  } catch (error) {
    return error.response;
  }
};
const bdService = {
  dsresbodegadet,
  dsdesbodegacab,
  dsdesbodegadet,
  dsMonitor,
  Inventario,
  Put_Inventario,
  Put_Inventario_Inicializar,
  Put_bodega_resbodegadet,
  Put_bodega_desbodegadet,
  Inventarioinforme,
};

export default bdService;
